module.exports = __webpack_public_path__ + "static/img/m-logo.9852d87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head/m-logo.png
// module id = +X1N
// module chunks = 29